<template>
  <div>
    <ClientHeader title="Cliente Nuevo" />
    <hr>
    <template v-if="products.length > 0">
      <ClientForm :products="products" :client="client" @onCreate="onCreate"/>
    </template>
    <template v-else>
      Loading..
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ClientHeader from '../ClientHeader'
import ClientForm from '../ClientForm'

export default {
  name: 'ClientNew',
  components: {
    ClientHeader,
    ClientForm
  },
  data () {
    return {
      products: [],
      client: {
        name: '',
        phone: null,
        address: '',
        email: '',
        paymentMethod: '',
        productPrices: [
          { id: null, price: 0.0 }
        ],
        deliverySchedule: [
          { startTime: '', endTime: '' }
        ],
        deliveryFrequency: '',
        notes: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ]),
    hasProducts () {
      return this.products.length > 0
    }
  },
  methods: {
    ...mapMutations([
      'toggleClientLoading'
    ]),
    ...mapActions([
      'createClient',
      'getProducts',
      'setAlertData'
    ]),
    loadProducts () {
      this.getProducts()
        .then((res) => {
          console.debug(res)
          res.forEach(doc => {
            this.products.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    onCreate (data) {
      this.toggleClientLoading(true)
      data.createdAt = new Date().getTime()
      this.createClient(data)
        .then((res) => {
          this.toggleClientLoading(false)
          this.$router.push({ name: 'Clients' })
          this.setAlertData({
            visible: true,
            msg: 'Client Creado ;)',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleClientLoading(false)
          console.log(err.toString())
        })
    }
  },
  created () {
    this.loadProducts()
  }
}
</script>
